"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function WhyBrassWhatItSFor() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: statsRef,
    isVisible: statsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const statement = "We exist for the precision manufacturers who see |durability| in the industrial—the fabricators, engineers, and builders who need their components to withstand the harshest environments for decades.";
  const words = statement.split(" ");
  const stats = [];
  return <section data-section-id="2249" id="why-brass-what-its-for" className="relative overflow-hidden bg-background text-foreground py-32 md:py-44 lg:py-[180px]">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 -z-0 h-[600px] w-[600px] -translate-x-1/2 -translate-y-[60%] rounded-lg opacity-[0.18] blur-3xl" style={{
      background: "radial-gradient(circle at center, var(--chart-1) 0%, transparent 70%)"
    }} />

      <div className="relative z-10 mx-auto max-w-6xl px-6">
        {}
        <div ref={eyebrowRef} className={`flex flex-col items-center transition-all duration-700 ease-out ${eyebrowVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div aria-hidden="true" className="h-px w-[60px]" style={{
          backgroundColor: "var(--chart-1)"
        }} />
          <span className="mt-6 font-default text-[12px] uppercase" style={{
          letterSpacing: "0.25em",
          color: "var(--chart-1)"
        }}>
            Our Mission
          </span>
        </div>

        {}
        <h2 ref={headlineRef} className="mx-auto mt-12 max-w-[880px] text-center font-default font-light leading-[1.2] text-foreground" style={{
        fontSize: "clamp(2rem, 5vw, 3.5rem)"
      }}>
          {words.map((word, i) => {
          const isItalic = word.startsWith("|") && word.endsWith("|");
          const cleanWord = isItalic ? word.slice(1, -1) : word;
          return <span key={i} data-index={i} className="inline-block transition-all ease-out" style={{
            opacity: headlineVisible ? 1 : 0,
            transform: headlineVisible ? "translateY(0)" : "translateY(20px)",
            transitionDuration: "800ms",
            transitionDelay: `${i * 60}ms`
          }}>
                {isItalic ? <em className="font-default italic" style={{
              fontWeight: 400
            }}>
                    {cleanWord}
                  </em> : cleanWord}
                {i < words.length - 1 && "\u00A0"}
              </span>;
        })}
        </h2>

        {}
        <div ref={statsRef} className={`mt-20 md:mt-24 lg:mt-[96px] transition-all duration-700 ease-out ${statsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
        transitionDelay: "300ms"
      }}>
          <div className="flex flex-col items-stretch gap-10 md:flex-row md:items-center md:justify-center md:gap-0">
            {stats.map((stat, i) => <div key={i} data-index={i} className="flex flex-1 items-center">
                <div className="flex flex-1 flex-col items-center text-center px-4 md:px-8">
                  <span className="font-default font-light leading-none text-foreground" style={{
                fontSize: "clamp(2.5rem, 4.5vw, 3.5rem)"
              }}>
                    {stat.number}
                  </span>
                  <span className="mt-4 font-default text-[11px] uppercase text-muted-foreground" style={{
                letterSpacing: "0.2em"
              }}>
                    {stat.label}
                  </span>
                </div>
                {i < stats.length - 1 && <Separator orientation="vertical" className="hidden md:block h-16 bg-border" />}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}